<template>
    <li>
      <div :class="wrapperClass">
        <div class="pr-1">
            <img class="handle icon ui-sortable-handle" src="@/assets/svg/more-vertical.svg">
        </div>
        <div class="input-table-shadow">
            <div class="d-flex row align-items-center">
              <div class="col-1 ml-3" v-click-outside="outsideCodeSearch">
                    <input
                        type="text"
                        :placeholder="$t('travels.navigation.design.service-code')"
                        @click="toggleCodeSearch"
                        v-model="item.service.code"
                    >
                    <core-paginated-drop-down
                        v-if="serviceTypes.length && showCodeSearch"
                        :filters="serviceTypes"
                        searchProperty="code"
                        filterPropertyName="serviceTypeId"
                        :item.sync="item.service"
                    ></core-paginated-drop-down>
                </div>
                <div class="col border-right" v-click-outside="outsideNameSearch">
                    <input
                        type="text"
                        :placeholder="$t('travels.navigation.design.service')"
                        @click="toggleNameSearch"
                        v-model="item.service.title_NL"
                    >
                    <core-paginated-drop-down
                        v-if="serviceTypes.length && showNameSearch"
                        :filters="serviceTypes"
                        filterPropertyName="serviceTypeId"
                        :item.sync="item.service"
                    ></core-paginated-drop-down>
                </div>
                <div class="col-1 border-right">
                    <core-day-input
                        :placeholder="$t('travels.navigation.design.service-from-day')"
                        :amount.sync="item.dayFrom"
                    ></core-day-input>
                </div>
                <div class="col-1 border-right">
                    <core-day-input
                        :placeholder="$t('travels.navigation.design.service-until-day')"
                        :amount.sync="item.dayUntil"
                    ></core-day-input>
                </div>
                <div class="col-1 border-right">
                    <select required="" class="right-chevron">
                        <option selected="" value="">Automatic</option>
                        <option value="0">Automatic</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                </div>
                <div class="col-2 border-right">
                    <core-lever :label="$t('travels.navigation.design.service-show-data')" v-model="item.showData"></core-lever>
                </div>
                <div class="col-2 border-right">
                    <core-lever :label="$t('travels.navigation.design.service-show-prices')" v-model="item.showPrices"></core-lever>
                </div>
                <div class="col-1">
                    <core-basic-drop-down
                        v-if="prio.length"
                        :items="prio"
                        :selection.sync="item.prio"
                    ></core-basic-drop-down>
                </div>
                <div class="col-1">
                  <input
                    type="text"
                    :placeholder="$t('travels.navigation.design.booking-prio')"
                    v-model="item.bookingPriority"
                  >
                </div>
            </div>
        </div>
        <div class="px-1 d-flex align-items-center">
            <img
                src="@/assets/svg/x-767676.svg"
                @click="deleteItem"
                class="icon"
                :title="$t('general.delete')"
            >
        </div>
      </div>
      <div v-for="backupLink in backupLinks" :key="backupLink.id ? backupLink.id : 'new'" v-if="isHotel">
        <core-backup-line :wrapperClass="wrapperClass" :backupLink="backupLink" :serviceTypes="serviceTypes"></core-backup-line>
      </div>
    </li>
</template>

<script>
import { clickOutside } from '@/mixins/clickOutside'
export default {
  data () {
    return {
      showCodeSearch: false,
      showNameSearch: false,
      prio: Array.from(new Array(31), (val, index) => index)
    }
  },
  mixins: [clickOutside],
  props: {
    wrapperClass: {
      default: 'd-flex justify-content-start move-item',
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: true
    },
    backupLinks: {
      type: Array,
      required: false
    },
    services: {
      default: () => [],
      type: Array,
      required: true
    },
    serviceTypes: {
      default: () => [],
      type: Array,
      required: true
    },
    primary: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  computed: {
    selectedValue () {
      return this.item.type
    },
    isHotel () {
      return this.item.service && this.item.service.serviceType && this.item.service.serviceType.code === 'ACCOMMODATION'
    },
    isTransport () {
      return this.item.service && this.item.service.serviceType && this.item.service.serviceType.code === 'TRANSPORT'
    }
  },
  mounted () {
    this.item.primary = this.primary
  },
  methods: {
    deleteItem () {
      this.$emit('delete')
    },
    toggleCodeSearch () {
      this.showCodeSearch = true
      if (this.showCodeSearch) {
        this.showNameSearch = false
      }
    },
    toggleNameSearch () {
      this.showNameSearch = true
      if (this.showNameSearch) {
        this.showCodeSearch = false
      }
    },
    outsideNameSearch () {
      this.showNameSearch = false
    },
    outsideCodeSearch () {
      this.showCodeSearch = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/ServiceListItem.vue